<template>
    <div class="row g-0">
        <div class="col-lg-3 col-12" style="display: flex;flex-direction: column;" >
            <button v-for="(sa_data, sa) in equip_point_info['beauty_sa']" v-bind:key="sa" class="point_btn" @click="equip_point_type = sa" :class="{active: equip_point_type == sa}" >{{sa}}：{{sa_data}}<span class="ms-2">A</span></button>
            <div class="point_btn_remain"></div>
        </div>
        <plot-zone v-if="equip_point_type !== null" v-bind:ID="string_meter_ID" v-bind:datatype="equip_point_type " v-bind:collection="'string_meter'" v-bind:key="equip_point_type"></plot-zone>

    </div>
</template>

<script>
import PlotZone from "./PlotZone.vue"

export default {
    name: "string_select_zone", 
    props: ["string_select"],
    components:{
        PlotZone
    },
    data(){
        return{
            string_meter_ID: this.$props.string_select,
            equip_point_type: null,
            equip_point_info: {}
        }
    },
    methods:{
        pv_string_data(){
            console.log(this.string_meter_ID)
            const that = this
            this.axios.get(`/pv_string_data?string_ID=${this.string_meter_ID}`)
            .then(function (data) {
                // 帶入params
                that.equip_point_info = data.data.data
                that.equip_point_info["beauty_sa"] = {}
                for(var i in that.equip_point_info["sa"]){
                    if(that.equip_point_info["sa"][i] !== "---"){
                        that.equip_point_info["beauty_sa"]["sa"+(parseInt(i)+1)] = that.equip_point_info["sa"][i]
                    }
                    if(that.equip_point_type == null){
                        that.equip_point_type = "sa"+(parseInt(i)+1)
                    }
                }
                console.log(that.equip_point_info)
            })
        }
    },
    mounted(){
        console.log(this.$props.string_select)
        this.syncdata = setInterval(this.pv_string_data, 5000)
        this.pv_string_data()
    },
    destroyed(){
        clearInterval(this.syncdata)
    }
}
</script>
<style src="../../assets/css/PlantInfo.css"></style>